<template>
    <v-list-item
        v-for="(item) in menu"
        :key="item.id"
        :href="item.url"
        @click.prevent="router.visit(item.url); overlayStore.setMenuOverlay(false)"
        :prepend-avatar="item.main_image.url"
        :active="activeMenu[item.id]"
        :append-icon="null"
        :class="{'has-overlay': overlayStore.overlayMenu}"
        role="listitem"
        class="c-menu-item"
        color="orange">
        <v-list-item-title>
            <div class="list-name font-weight-bold text-black">{{ item.name }}</div>
        </v-list-item-title>
        <template v-slot:prepend>
            <v-img :src="item.main_image.url" class="mr-2 ml-n1" :alt="item.name" :width="24"
                   :class="overlayStore.overlayMenu?'colored':'grayscale'"></v-img>
        </template>
        <v-menu
            v-if="item.children.length"
            activator="parent"
            open-on-hover
            close-on-content-click
            @update:model-value="toggleOverlay"
            transition="none"
            location="right top"
            open-delay="50"
            close-delay="50"
            :width="subMenuWidth"
            class="c-app-bar__menu"
        >
            <v-container class="pa-8 bg-white rounded rounded-ts-0">
                <v-row align="center">
                    <v-col cols="auto">
                        <h4 class="text-h6 font-weight-black">{{ item.name }}</h4>
                    </v-col>
                    <v-col>
                        <v-btn
                            href="/"
                            @click.prevent="router.visit(item.url)"
                            class="text-orange text-decoration-underline px-1 text-body-3"
                            variant="text"
                        >
                            <template v-slot:append>
                                <v-icon :icon="mdiChevronRight" class="ml-n1"></v-icon>
                            </template>
                            <p>
                                <span>{{ $t('app-bar.show_everything_in') }}</span>
                                <span>&nbsp;</span>
                                <span class="font-weight-bold">{{ item.name }}</span>
                            </p>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row class="gc-2 pa-2">
                    <template v-for="(child, i) in item.children" :key="i">
                        <v-col class="lg5-custom pa-0 mb-2 ">
                            <Link :href="child.url">
                                <v-card class="d-flex align-center elevation-0 rounded-md pa-0 c-card" height="100%">
                                    <v-card-text class="d-flex align-center pa-2">
                                        <v-avatar
                                            v-if="child.main_image"
                                            rounded="0"
                                            size="64">
                                            <v-img :width="64" :src="child.main_image.url+'?width=128'" aspect-ratio="1"
                                                   cover="cover"
                                                   :alt="child.main_image?.alt"
                                            ></v-img>
                                        </v-avatar>
                                        <div class="px-2 pr-4">
                                            <div class="text-body-2 font-weight-black mr-1">
                                                {{ child.name }}
                                                <span v-if="!countStore.loading && countStore.counts[child.id]"
                                                      class="opacity-50 text-small">({{ countStore.counts[child.id]
                                                    }})</span>
                                                <v-icon v-if="countStore.loading" :icon="mdiLoading"
                                                        class="animation-rotate"></v-icon>
                                            </div>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </Link>
                        </v-col>
                    </template>
                </v-row>
            </v-container>
        </v-menu>
    </v-list-item>
    <v-list-item
        v-if="newsGroup.id"
        :active="activeMenu[newsGroup.id]"
        class="c-menu-item"
        :class="{'has-overlay': overlayStore.overlayMenu}"
        color="orange"
        role="listitem"
        :href="newsGroup.url"
        @click.prevent="router.visit(newsGroup.url);overlayStore.setMenuOverlay(false)"
    >
        <v-list-item-title>
            <div class="font-weight-light">{{ newsGroup.name }}</div>
        </v-list-item-title>
    </v-list-item>
    <v-list-item
        v-if="actionGroup.id"
        role="listitem"
        :active="activeMenu[actionGroup.id]"
        class="c-menu-item"
        :class="{'has-overlay': overlayStore.overlayMenu}"
        color="orange"
        :href="actionGroup.url"
        @click.prevent="router.visit(actionGroup.url)"
    >
        <v-list-item-title>
            <div class="font-weight-light">{{ actionGroup.name }}</div>
        </v-list-item-title>
    </v-list-item>
</template>
<script setup>
import { Link, router } from '@inertiajs/vue3';
import { useOverlayStore } from './store/overlay';
import { computed, onUnmounted } from 'vue';
import pinia from '../../../plugins/pinia';
import { mdiChevronRight, mdiLoading } from '@mdi/js';
import { debounce } from 'lodash-es';
import categoryCountStore from '../../../../../Modules/Eshop/Resources/js/composables/categoryCountStore.js';

const props = defineProps({
    menu: Array,
    subMenuWidth: Number,
    activeMenu: Object,
    menuModel: Array,
});
const countStore = categoryCountStore(pinia);
const overlayStore = useOverlayStore(pinia);

const menu = computed(() => {
    return props.menu.filter((item) => {
        return !item.action && !item.news;
    });
});

const actionGroup = computed(() => {
    return props.menu.filter((item) => {
        return item.action;
    }).pop();
});

const newsGroup = computed(() => {
    return props.menu.filter((item) => {
        return item.news;
    }).pop();
});

onUnmounted(() => {
    overlayStore.overlayMenu = false;
});

let fn;
const toggleOverlay = (val) => {
    if (!val) {
        fn = debounce(() => {
            overlayStore.setMenuOverlay(false);
        }, 100);
        fn();
    } else {
        overlayStore.setMenuOverlay(val);
        if (fn) {
            fn.cancel();
            fn = null;
        }
    }

};
</script>
<style scoped lang="scss">
@use './../../../../../resources/js/plugins/vuetify-settings.scss' as *;
@use 'sass:map';

.c-menu-item:not(:last-child) {
    border-bottom: 1px solid map.get($grey, 'lighten-2');
}

.c-card {
    border: 1px solid map.get($grey, 'lighten-2');
}

.grayscale {
    filter: invert(65%) sepia(58%) saturate(0%) hue-rotate(283deg) brightness(91%) contrast(92%);
}

.colored {
    filter: invert(73%) sepia(46%) saturate(5792%) hue-rotate(347deg) brightness(98%) contrast(89%);
}

.v-list-item {
    &.has-overlay:not([aria-expanded=true]) {
        background-color: rgba(0, 0, 0, 0.3);
        border-bottom: 1px solid rgba(0, 0, 0, 0.07);

        &:not(:first-child) {
            border-top: 1px solid rgba(0, 0, 0, 0.07);
        }

        .v-img {
            filter: brightness(.5);
        }
    }

    &[aria-expanded=true] {
        background-color: white !important;
        opacity: 1;
        --v-theme-overlay-multiplier: 0;

        .list-name {
            color: map.get($orange, 'base') !important;
        }
    }
}

.lg5-custom {
    width: 19%;
    max-width: 19%;
    flex-basis: 19%;
}
</style>
